module.exports = __webpack_public_path__ + "img/galaxi-tab.00b2678e.png";